import React, { Component } from 'react';
import { Tabs, Row, Col } from 'antd';
import { connect } from 'react-redux';
import CourseForm from '../../components/editcourseform/courseform';
import CourseCurriculum from '../../components/editcoursecurriculum/coursecurriculum';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import { getCourse, getSections } from '../../../../core/actions/courseGet';
import { uploadMedia,getMedia } from '../../../../core/actions/storageStore';
import { editSection,editCourse, deleteCourse } from '../../../../core/actions/coursePost';
import Draggable from './draggable';
import { bindActionCreators } from "redux"
// import Batchupload from '../../components/batchupload';
// import Uploadedvideos from '../../components/uploadedvideos';

const TabPane = Tabs.TabPane;

class CourseEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabStyle: 'left',
      refresh:false
    };
  }

  componentWillMount() {
    const { slug } = this.props.match.params;
    this.props.getCourse(slug);
    this.props.getSections(slug);
    // eslint-disable-next-line no-undef
    const role = localStorage.getItem('role');
    if (role !== 'admin') {
      this.props.history.goBack();
    }
    this.switchTabStyle()
  }
  
  componentWillReceiveProps(nextProps) {
    const { deleteSuccess, deleteError } = nextProps.courseAction
    if(deleteSuccess) {
      this.props.history.push('/courses')
    }
  }

  switchTabStyle = () => {
    let size = window.innerWidth
    if (size <= 415) {
      this.setState({
        tabStyle: 'top'
      })
    }
  }
  refreshVideos = ()=>{
    this.setState({refresh:true},()=>this.setState({refresh:false}))
  }
  render() {
    const { tabStyle } = this.state
    // console.log(this.props.sections)
    return (
      <div>
        <TopNav history={this.props.history} />
        <section id="course-upload">
          <Tabs size="large" defaultActiveKey="1" tabPosition={tabStyle}>
            <TabPane tab="Course Home Page" key="1">
              <Row>
                <Col lg={16} sm={24}>
                  {this.props.course.title && <CourseForm 
                  editCourse={this.props.editCourse}
                  deleteCourse={this.props.deleteCourse}
                  courseData={this.props.course} 
                  courseId={this.props.course.id} 
                  course={this.props.courseReducer}
                  sections={this.props.sections}
                  refreshVideos={this.refreshVideos}
                  refresh={this.state.refresh}
                  getMedia={this.props.getMedia}
                   profile={this.props.profile}
                  uploadMedia={this.props.uploadMedia} 
                  media={this.props.media}/>}
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Curriculum" key="2">
              <Row>
                <Col lg={16} sm={24}>
                  {this.props.sections.length > 0 && <CourseCurriculum
                    courseId={this.props.course.id}
                  course={this.props.courseReducer}
                  sections={this.props.sections}
                  editSection={this.props.editSection}
                    refreshVideos={this.refreshVideos}
                    refresh={this.state.refresh}
                    getMedia={this.props.getMedia}
                     profile={this.props.profile}
                    uploadMedia={this.props.uploadMedia} 
                    media={this.props.media}
                  />}
                </Col>
                <Col lg={8} sm={24}>
                  {this.props.sections.length > 0 && <Draggable
                    courseId={this.props.course.id}
                    sections={this.props.sections}
                    editSection={this.props.editSection}
                  />}
                </Col>
              </Row>
            </TabPane>
            {/* <TabPane tab="Upload Videos" key="3">
            <Row>
                <Col lg={24} sm={24} xs={24}>
                   <Batchupload 
                   refreshVideos={this.refreshVideos}
                   profile={this.props.profile}
                  uploadMedia={this.props.uploadMedia} 
                  />
                  </Col>
            </Row>
            </TabPane>
            <TabPane tab="Uploaded Videos" key="4">
            <Row>
                <Col lg={24} sm={24} xs={24}>
                   <Uploadedvideos 
                  media={this.props.media}
                  profile={this.props.profile}
                  refresh={this.state.refresh}
                   getMedia={this.props.getMedia}/>
                  </Col>
            </Row>
            </TabPane> */}
          </Tabs>
        </section>
        <Footer />
      </div>
    );
  }
}


const mapStateToProps = state => ({
  firebase: state.firebase,
  profile: state.firebase.profile,
  courseReducer: state.course,
  course: state.getCourses.course,
  sections: state.getCourses.sections,
  media: state.getMedia.media,
  courseAction: state.course

});
const mapDispatchToProps = dispatch => bindActionCreators({
  getSections,
  getCourse,
  editSection,
  editCourse,
  uploadMedia,
  getMedia,
  deleteCourse
}, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseEdit);
